<template>
  <div class="fullpage-container">
    <div class="menu">
      <div class="menu-left">
        <img src="@/assets/pc/top_logo.png" style="cursor:pointer;" @click="moveto(0)">
      </div>
      <div class="menu-right">
        <div class="menu-right-top">
          <img class="service-icon" src="@/assets/pc/icon_cs.png">
          <img class="service-icon" @click="goHandy" src="@/assets/pc/icon_service.png">
          <img class="service-icon" src="@/assets/pc/icon_google.png">
        </div>
        <div class="menu-right-bot">
          <ul class="gnb">
              <li><a @click="moveto(0, 'category')">HOME</a></li>
              <li><a @click="moveto(2, 'category')">사용후기</a></li>
              <li><a @click="moveto(4, 'category')">인공지능세리</a></li>
              <li><a @click="moveto(9, 'category')">서비스문의</a></li>
              <li><a @click="moveto(10, 'category')">이벤트</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="fullpage-wp" v-fullpage="opts" ref="main">
        <!-- <button type="button" v-for="(btn, index) in pageNum" :key="index" :class="{active:index == btn + 2}" @click="moveTo(btn+2)">page {{btn+2}}</button> -->
        <div class="page-1 page">
          <img src="@/assets/pc/test_main1.png" style="width:100%;object-fit:contain;">
          <!-- <div class="page-2-content-1">
            <span class="font48" style="color:#2d2d2d;font-size: 2.5vw;">인공지능 세리</span>
            <span class="font48" style="color:#6E6E6E;font-weight:bold;margin: 20px 0px 10px 0px;">매장 통합 시스템</span>
            <hr style="margin:0;border: 3px solid #2d2d2d;width:110px;margin:30px 0px;">
            <p style="text-align:left;color:#2d2d2d;font-size: 1.2vw;line-height: 35px;">
              스마트 전단지 문자<br>
              무료 POP 제작 / 출력<br>
              온라인 매장 운영(주문 / 배달)
            </p>
          </div> -->
        </div>
        <div class="page-2 page">
          <img src="@/assets/pc/main2.png" style="width:100%;object-fit:contain;">
          <div class="page-2-content-1">
            <span class="font48" style="color:#ffffff;font-size: 2.5vw;">세리서비스</span>
            <span class="font48" style="color:#ffffff;font-weight:bold;margin: 20px 0px 10px 0px;">이용하기</span>
            <hr style="margin:0;border: 3px solid #ffffff;width:110px;margin:20px 0px;">
            <p style="text-align:left;color:#2d2d2d;font-size: 1.2vw;line-height: 35px;color:#ffffff;margin:30px 0px;">
              무료 체험과 동시에 3만원 무료 충전
            </p>
            <button class="trial-btn1" @click="openJoin">무료체험하기</button>
          </div>
        </div>
        <div class="page-4 page">
          <div class="review-top">
            <h1>
              현재 전국 760여개 매장과 함께하는 SERY 서비스<br>
            </h1>
            <h2 style="width:100%;color:#6E6E6E;">
              마트·정육점·기타 업종까지 생생한 후기를 만나보세요
            </h2>
          </div>
          <div class="review-mid">
            <div style="width:70%;display:flex;">
              <div class="review-mid-side" style="border-right: 2px solid #CACACC">
                <h1 style="font-weight:500;margin:0;">{{numberWithCommas(22337561)}}</h1>
                <h3 style="font-weight:500;">세리 스마트전단 받은 고객</h3>
              </div>
              <div class="review-mid-center">
                <h1 style="font-weight:500;margin:0;">{{numberWithCommas(1574125)}}</h1>
                <h3 style="font-weight:500;">온라인 상품 수</h3>
              </div>
              <div class="review-mid-side" style="border-left: 2px solid #CACACC">
                <h1 style="font-weight:500;margin:0;">{{numberWithCommas(3009994)}}</h1>
                <h3 style="font-weight:500;">함께하는 고객</h3>
              </div>
            </div>
          </div>
          <div class="review-bot">
            <div class="bot-inner" style="justify-content: flex-end;">
              <img src="@/assets/pc/client-percent.png" style="width:70%;object-fit:contain;">
            </div>
            <div class="bot-inner" style="justify-content: flex-start;">
              <img src="@/assets/pc/client-cost.png" style="width:70%;object-fit:contain;">
            </div>
          </div>
        </div>
        <div class="page-6 page">
          <div class="review2">
            <div class="review2-left">
              <div class="review2-left-1">
                <div class="review2-store-name-div">
                  <span class="review2-store-name">
                    부산 연제구 고기** 정육점&emsp;
                  </span>
                  &emsp;&emsp;<img src="@/assets/pc/star4.png" alt="">
                </div>
                <div>
                <p style="text-align:left;color:#6E6E6E;font-size: 1vw;line-height: 35px;margin:0;">
                  <br>매장에 행사 있을때 마다 고기 사진을 프린트 해서 붙여 놓는데, 스마트 POP로 뽑으니까 간편해서<br>
                  참 좋네요~ 바쁠때 특히 잘 이용하고 있습니다. 추천하고 싶네요~
                </p>
                </div>
              </div>
              <div class="review2-left-2">
                <img src="@/assets/pc/business02.png" style="width:100%;object-fit:contain;" alt="">
              </div>
              <div class="review2-left-3">
                <div class="review2-store-name-div">
                  <span class="review2-store-name">
                    경기 구리시 프*마트&emsp;
                  </span>
                  &emsp;&emsp;<img src="@/assets/pc/star5.png" alt="">
                </div>
                <div>
                <p style="text-align:left;color:#6E6E6E;font-size: 1vw;line-height: 35px;margin:0;">
                  <br>스마트전단을 받은 손님들 반응이 참 좋아요~ 사진이 다 등록되어있어서 금방 만드는데,<br>
                  상품 사진이 바로 보이니까 예쁘고 한눈에 잘 들어온다고 칭찬 받았네요^^
                </p>
                </div>
              </div>
              <div class="review2-left-4">
                <img src="@/assets/pc/business04.png" style="width:100%;object-fit:contain;" alt="">
              </div>
            </div>
            <div class="review2-left">
              <div class="review2-left-2">
                <img src="@/assets/pc/business01.png" style="width:100%;object-fit:contain;" alt="">
              </div>
              <div class="review2-left-1">
                <div class="review2-store-name-div">
                  <span class="review2-store-name">
                    서울 구로구 경*할인마트&emsp;
                  </span>
                  &emsp;&emsp;<img src="@/assets/pc/star5.png" alt="">
                </div>
                <div>
                <p style="text-align:left;color:#6E6E6E;font-size: 1vw;line-height: 35px;margin:0;">
                  <br>행사 문자 보낼때마다 비용도 많이 들고 귀찮아서 항상 스트레스였는데, 세리 가입한 후로는<br>
                  비용도 훨씬 저렴하고 이용방법도 간단해서 금방하네요~ 다른 매장에도 추천했습니다. ㅎㅎ
                </p>
                </div>
              </div>
              <div class="review2-left-4">
                <img src="@/assets/pc/business03.png" style="width:100%;object-fit:contain;" alt="">
              </div>
              <div class="review2-left-3">
                <div class="review2-store-name-div">
                  <span class="review2-store-name">
                    경남 창원시 싱싱** 마트&emsp;
                  </span>
                  &emsp;&emsp;<img src="@/assets/pc/star3.png" alt="">
                </div>
                <div>
                <p style="text-align:left;color:#6E6E6E;font-size: 1vw;line-height: 35px;margin:0;">
                  <br>행사 상품 갯수가 100개가 넘는데 행사파일 받은걸로 바로 스마트전단을 만들 수 있으니<br>
                  신기하기도 하고 시간 절약 되네요!!! 만족합니다.
                </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-7 page">
          <div class="aiSery-div">
            <img src="@/assets/pc/ai-main.png" class="aiSery-main">
            <!-- <div class="aiSery-content">
              <span class="font48" style="color:#2d2d2d;">스마트한</span>
              <span class="font48" style="color:#6E6E6E;font-weight:bold;">전단지 문자발송</span>
              <hr style="margin:0;border: 4px solid #2d2d2d;width:110px;margin:20px 0px;">
              <p style="text-align:left;color:#2d2d2d;font-size: 1.2vw;line-height: 35px;">
                1초만에 제작하는 스마트 전단지<br>
                확실한 효과 <br>
                잦은 매장 행사시 많은 번거로움을 한번에 해결
              </p>
            </div> -->
          </div>
        </div>
        <div class="page-9 page">
          <div class="service-pop">
            <img src="@/assets/pc/bg_img.png" class="rcs-main-img">
            <!-- <div class="service-pop-left"> -->
              <!-- <div class="service-pop-content">
                <span class="font48" style="color:#2d2d2d;">매장 내 POP</span>
                <span class="font48" style="color:#6E6E6E;font-weight:bold;">제작 / 출력 무료</span>
                <hr style="margin:0;border: 4px solid #2d2d2d;width:110px;margin:40px 0px;">
                <p style="text-align:left;color:#2d2d2d;font-size: 1.2vw;line-height: 35px;margin:0;">
                  매장운영에 꼭 필요한 POP<br>
                  세리 서비스를 통해 무료로 해결
                </p>
              </div> -->
              <!-- <div class="service-pop-content-icon">
                <img src="@/assets/pc/icon01.png" alt="">
                <img src="@/assets/pc/icon02.png" alt="">
                <img src="@/assets/pc/icon03.png" alt="">
              </div> -->
            <!-- </div> -->
            <!-- <div class="service-pop-right"> -->
              <!-- <img src="@/assets/pc/bg_img.png"> -->
            <!-- </div> -->
          </div>
        </div>
        <div class="page-10 page">
          <div class="service-tery">
            <div class="tery-left">
              <img src="@/assets/pc/new_tery_main.png" class="service-tery-main">
            </div>
            <div class="tery-right">
              <span class="tery-title">테리 온라인 매장</span>
              <span class="tery-title2">주문 / 배달</span>
              <hr class="kakao-hr">
              <span class="tery-title3">오프라인 매장을 운영하고 있다면 온라인 판매도 가능하게 해주는 테리</span>
              <span class="tery-title3">고객은 테리로 주문하고 매장은 테리로 배달하고</span>
              <br><br><br>
              <div class="tery-icons-div">
                <img src="@/assets/pc/tery_icon01.png" class="tery-icons-img">
                <img src="@/assets/pc/tery_icon02.png" class="tery-icons-img">
                <img src="@/assets/pc/tery_icon03.png" class="tery-icons-img">
                <img src="@/assets/pc/tery_icon04.png" class="tery-icons-img">
              </div>
            </div>
          </div>
        </div>
        <div class="page-11 page">
          <div class="rcs-main">
            <img src="@/assets/pc/rcs_main.png" class="rcs-main-img" alt="">
            <!-- <div class="rcs-content">
              <span class="font48" style="color:#2d2d2d;">신규버전</span>
              <span class="font48" style="color:#6E6E6E;font-weight:bold;">문자 3.0 기능 적용</span>
              <hr style="margin:0;border: 4px solid #2d2d2d;width:110px;margin:40px 0px;">
              <p style="text-align:left;color:#2d2d2d;font-size: 1.2vw;line-height: 35px;margin:0;">
                가장 핵심이 되는 고객!<br>
                고객이 가장 편하게 볼 수 있는 문자<br><br>
                매장으로 바로 전화 가능<br>
                스마트전단 클릭률 증가<br>
                고객이 지인에게 자발적으로 공유<br>
              </p>
            </div> -->
          </div>
        </div>
        <div class="page-12 page">
          <div class="kakao-main">
            <div class="kakao-main-left">
              <img src="@/assets/pc/kakao_main.png" class="kakao-main-img" alt="">
            </div>
            <div class="kakao-main-right">
              <span class="kakao-title">kakao</span>
              <span class="kakao-title2">발송서비스 지원</span>
              <hr class="kakao-hr">
              <span class="kakao-title3">카카오톡으로</span>
              <span class="kakao-title3">행사내용을 발송할 수 있습니다.</span>
              <br><br>
              <span class="kakao-title3">문자와 함께 카카오톡으로</span>
              <span class="kakao-title3">스마트전단을 발송하여</span>
              <span class="kakao-title3">매장행사를 알리세요.</span>
              <br><br>
              <br><br>
              <br><br>
              <br><br>
              <br><br>
              <br><br>
            </div>
          </div>
        </div>
        <div class="page-13 page">
          <div class="question-main">
            <div class="question-top">
              <div class="question-top-left">
                <google-map id="map" ref="Map" :options="mapOptions">
                  <google-map-marker
                      v-for="(infoWindow, index) in infoWindowsList"
                      :position="infoWindow.position"
                      :key="index"
                      @click="toggleInfoWindow(infoWindow)"
                  />
                  <google-map-infowindow
                      :position="infoWindowContext.position"
                      :show.sync="showInfo"
                      :options="{maxWidth: 300}"
                      @info-window-clicked="infoClicked"
                  >
                    <h4>{{infoWindowContext.title}}</h4>
                    <p>{{infoWindowContext.description}}</p>
                  </google-map-infowindow>
                </google-map>
              </div>
              <div class="question-top-right">
                <div class="top-right-inner">
                  <img src="@/assets/pc/icon_markup.png" style="height:57px; object-fit:contain;" class="top-right-img" alt="">
                  <span class="top-right-content">
                    대한민국 부산광역시 해운대구 센텀북대로 60<br>
                    센텀IS타워 415호
                  </span>
                </div>
                <div class="top-right-inner">
                  <img src="@/assets/pc/icon_mail.png" style="margin:0px 15px; width:51px; object-fit:contain;" class="top-right-img" alt="">
                  <span class="top-right-content">
                    cs@tonovation.com
                  </span>
                </div>
                <div class="top-right-inner">
                  <img src="@/assets/pc/icon_phone.png" style="height:53px; object-fit:contain;" class="top-right-img" alt="">
                  <span class="top-right-content">
                    1661-9068
                  </span>
                </div>
                <!-- <img src="@/assets/pc/list_address.png" alt="">
                <img src="@/assets/pc/list_email.png" alt="">
                <img src="@/assets/pc/list_phone.png" alt=""> -->
              </div>
            </div>
            <div class="question-bot">
              <div class="question-bot-top">
                <span style="font-size: 2vw;">서비스</span>&nbsp;
                <span style="font-size: 2vw;font-weight: bold;color: #6E6E6E;">문의</span>
              </div>
              <div class="question-bot-bot">
                <div class="bot-bot-left">
                  <img src="@/assets/pc/standard_icon.png" style="margin-bottom: 20px;">
                  <div style="width:100%;height:auto;margin:10px 0px;">
                    <input type="text" class="input-text" v-model="qnaData.userName" placeholder="이름">
                  </div>
                  <div style="width:100%;height:auto;margin:10px 0px;">
                    <input type="text" class="input-text" v-model="qnaData.userEmail" placeholder="이메일">
                  </div>
                  <div style="width:100%;height:auto;margin:10px 0px;">
                    <input type="tel" class="input-text" v-model="qnaData.phone" placeholder="전화번호">
                  </div>
                  <div style="width:100%;height:auto;margin:10px 0px;">
                    <textarea class="input-content" v-model="qnaData.userContents" placeholder="문의내용"/>
                  </div>
                  <div style="width:100%;height:auto;margin:10px 0px;text-align:right;">
                    <button class="btn-question" @click="sendMail1(0)">문의하기</button>
                  </div>
                </div>
                <div style="flex: 1;">

                </div>
                <div class="bot-bot-left">
                  <img src="@/assets/pc/addFunc_icon.png" style="margin-bottom: 20px;">
                  <div style="width:100%;height:auto;margin:10px 0px;">
                    <input type="text" class="input-text" v-model="orderData.userName" placeholder="이름">
                  </div>
                  <div style="width:100%;height:auto;margin:10px 0px;">
                    <input type="text" class="input-text" v-model="orderData.userEmail" placeholder="이메일">
                  </div>
                  <div style="width:100%;height:auto;margin:10px 0px;">
                    <input type="tel" class="input-text" v-model="orderData.phone" placeholder="전화번호">
                  </div>
                  <div style="width:100%;height:auto;margin:10px 0px;">
                    <textarea class="input-content" v-model="orderData.userContents" placeholder="요청내용"/>
                  </div>
                  <div style="width:100%;height:auto;margin:10px 0px;text-align:right;">
                    <button class="btn-question" @click="sendMail1(1)">요청하기</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page-14">
          <div class="event-top">
            <img src="@/assets/pc/event_main1.png" style="height:100%;object-fit:contain;" alt="">
          </div>
          <div class="event-body">
            <img src="@/assets/pc/event_main2.png" style="height:100%;object-fit:contain;" alt="">
          </div>
          <div class="event-bot">
            <div style="display:flex;  align-items: center;justify-content: center;">
              <span class="event-word">고객문의</span>
              <span class="event-div">|</span>
              <span class="event-word">카카오문의</span>
            </div>
            <div style="display:flex;  align-items: center;justify-content: center;margin: 15px 0px;">
              <img src="@/assets/pc/naver_icon.png" class="kakao-naver" alt="">
              <img src="@/assets/pc/kakao_icon.png" class="kakao-naver" alt="">
            </div>
            <div style="display:flex;align-items:center;justify-content: center;flex-direction:column;">
              <span class="reserved">ⓒ 2018 tonovation, All rights reserved.</span>
              <span class="reserved">토노베이션</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagenation">
      <div @click="moveto(0)" :class="[currentPage !== 0 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(1)" :class="[currentPage !== 1 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(2)" :class="[currentPage !== 2 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(3)" :class="[currentPage !== 3 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(4)" :class="[currentPage !== 4 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(5)" :class="[currentPage !== 5 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(6)" :class="[currentPage !== 6 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(7)" :class="[currentPage !== 7 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(8)" :class="[currentPage !== 8 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(9)" :class="[currentPage !== 9 ? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
      <div @click="moveto(10)" :class="[currentPage !== 10? 'pagination-bullet-off' : 'pagination-bullet-on']"></div>
    </div>
    <div class="btn-div">
      <h3 style="margin:5px 0px;color:#E62B73;">30,000원 무료충전</h3>
      <button class="btn-promo" @click="openJoin">무료체험신청</button>
      <!-- <button class="btn-kakao">
        <img src="@/assets/pc/icon_kakao.png" alt="">
        <span>&nbsp;카톡상담</span>
      </button> -->
      <div id="create-channel-chat-button"></div>
    </div>
    <modal name="promoModal" :width="300" :height="'auto'">
      <div class="modalMain" v-if="joinFlag === 0">
        <div class="modalHead">
          <img src="@/assets/logo.png" class="modalLogo" alt="">
          <h2>무료체험신청</h2>
          <span class="promo-content">
            무료체험에 이용할<br>아이디와 비밀번호를 설정해 주세요.
          </span>
        </div>
        <div class="modalBody">
          <div class="id-div">
            <label for="userId" class="id-label">
              아이디
            </label>
            <input type="text" name="userId" id="userId" class="input-id" v-model="userId">
          </div>
          <div class="id-div">
            <label for="userPw" class="id-label">
              비밀번호
            </label>
            <input type="password" name="userPw" id="userPw" class="input-id" v-model="userPw">
            <input type="password" name="chkUserPw" id="chkUserPw" class="input-id" v-model="chkUserPw" placeholder="비밀번호를 한번 더 입력하세요.">
          </div>
        </div>
        <div class="modalFoot">
          <button class="modalRegBtn" @click="joinSery">신&nbsp;청&nbsp;하&nbsp;기</button>
        </div>
      </div>
      <div class="modalBody" v-else>
        <div class="modalHead">
          <img src="@/assets/icon-party-cracker.png" alt="">
          <h2 style="margin: 0; font-size: 27px;color:#D32364;font-weight:bold;">
            30,000 충전완료 !
          </h2>
        </div>
        <div class="modalBody">
          <button class="btn-goSery" @click="goHandy">확인하러가기</button>
        </div>
        <div class="modalFoot">
          <h2>
            문의 1661-9068
          </h2>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import cities from '@/assets/cities.json'
import axios from 'axios'
import CryptoJS from 'crypto-js'
export default {
  name: 'main',
  created () {
    setTimeout(() => {
      this.isShowPage = false
    }, 2000)
  },
  watch: {
    userId () {
      const regExp = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]*$/
      if (regExp.test(this.userId)) {
        if (this.userId !== '') {
          this.userId = ''
          alert('한글은 사용할 수 없습니다.')
        }
      } else {
        var str = this.userId
        console.log('str:::', str)
        for (let i = 0; i < str.length; i++) {
          if ((str[i] >= '0' && str[i] <= '9') || (str[i] >= 'a' && str[i] <= 'z')) {
            console.log('소문자')
          } else {
            this.userId = ''
            alert('ID는 영문 소문자 및 숫자만 가능합니다.')
          }
        }
      }
    }
  },
  data () {
    return {
      joinFlag: 0,
      showInfo: false,
      mapOptions: {
        zoom: 16,
        minZoom: 3,
        center: {
          lat: 35.17665784125602,
          lng: 129.12537592501636
        },
        draggable: false,
        streetViewControl: false,
        scrollwheel: false,
        mapTypeControl: false
      },
      infoWindowContext: {
        position: {
          lat: 35.17665784125602,
          lng: 129.12537592501636
        },
        title: '토노베이션',
        description: '회사'
      },
      infoWindowsList: cities,
      currentPage: 0,
      hPages: {
        page1: 0,
        page2: 0,
        page3: 0
      },
      isShowPage: true,
      pageNum: 0,
      // opts1: {
      //   start: 0,
      //   dir: 'h',
      //   duration: 300,
      //   loop: false,
      //   afterChange: (prev, next) => {
      //     this.hPages.page1 = next
      //     console.log('horizontal')
      //   }
      // },
      opts: {
        // 전체 세로 scroll
        start: 0,
        dir: 'v',
        duration: 300,
        loop: false,
        autoScrolling: false,
        scrollHorizontally: false,
        afterChange: (prev, next) => {
          this.currentPage = next
          this.sendGtag(next)
        }
      },
      qnaData: {
        userName: '',
        userEmail: '',
        phone: '',
        userContents: '',
        flag: 3
      },
      orderData: {
        userName: '',
        userEmail: '',
        phone: '',
        userContents: '',
        flag: 4
      },
      userPw: '',
      chkUserPw: '',
      userId: ''
    }
  },
  mounted () {
    this.$gtag.event(`PC_홈페이지_HOME1`, {
      'event_category': 'PC_접속'
    })
  },
  methods: {
    moveNext () {
      console.log('next')
      this.$refs.main.$fullpage.moveNext()
    },
    sendGtag (val, cagetory) {
      const vm = this
      if (this.$empty(cagetory)) {
        cagetory = 'none'
        switch (val) {
          case 0:
            mountPage('PC_홈페이지_HOME1')
            break
          case 1:
            mountPage('PC_홈페이지_HOME2')
            break
          case 2:
            mountPage('PC_홈페이지_사용후기1')
            break
          case 3:
            mountPage('PC_홈페이지_사용후기2')
            break
          case 4:
            mountPage('PC_홈페이지_인공지능세리_전단지')
            break
          case 5:
            mountPage('PC_홈페이지_인공지능세리_POP')
            break
          case 6:
            mountPage('PC_홈페이지_인공지능세리_테리')
            break
          case 7:
            mountPage('PC_홈페이지_인공지능세리_문자3.0')
            break
          case 8:
            mountPage('PC_홈페이지_인공지능세리_카카오')
            break
          case 9:
            mountPage('PC_홈페이지_서비스문의')
            break
          case 10:
            mountPage('PC_홈페이지_이벤트')
            break
        }
      } else {
        switch (val) {
          case 0:
            mountPage('PC_홈페이지_HOME_카테고리')
            break
          case 2:
            mountPage('PC_홈페이지_사용후기_카테고리')
            break
          case 4:
            mountPage('PC_홈페이지_인공지능세리_전단지_카테고리')
            break
          case 9:
            mountPage('PC_홈페이지_서비스문의_카테고리')
            break
          case 10:
            mountPage('PC_홈페이지_이벤트_카테고리')
            break
        }
      }
      function mountPage (pageName) {
        vm.$gtag.event(`${pageName}`, {
          'event_category': 'PC_접속'
        })
      }
    },
    moveto (val, category) {
      this.currentPage = val
      this.$refs.main.$fullpage.moveTo(val, true, true)
      if (!this.$empty(category)) {
        this.sendGtag(val, category)
      } else {
        this.sendGtag(val)
      }
    },
    page1Hmove (val) {
      this.$refs.page2.$fullpage.moveTo(val, true, true)
    },
    page2Hmove (val) {
      this.$refs.page3.$fullpage.moveTo(val, true, true)
    },
    page3Hmove (val) {
      this.$refs.page4.$fullpage.moveTo(val, true, true)
    },
    showPage () {
      console.log('next')
      this.pageNum++
      this.$refs.fullpage.$fullpage.$update()
    },
    loopFirstPage () {
      this.$refs.page2.$fullpage.moveNext()
    },
    toggleInfoWindow (context) {
      this.infoWIndowContext = context
      this.showInfo = true
    },
    infoClicked (context) {
      console.log(context)
    },
    sendMail1 (val) {
      var data = val === 0 ? this.qnaData : this.orderData
      if (this.$empty(data.userName) ||
      this.$empty(data.userEmail) ||
      this.$empty(data.phone) ||
      this.$empty(data.userContents)) {
        alert('내용을 확인해 주세요.')
      } else {
        var tmp1 = `${val === 0 ? '[세리일반문의] ' : '[추가기능요청] '} ${data.userName}`
        var tmp2 = `${data.userContents} \n 전화번호: ${data.phone}`
        data.name = tmp1
        data.userContents = tmp2
        this.$axios({
          // url: `http://192.168.0.2:9090/sendEmail`,
          url: 'https://sery.co.kr/sendEmail',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          },
          method: 'post',
          data: data
        })
          .then(response => {
            console.log(response)
            if (response.status === 200) {
              alert('문의가 접수되었습니다.')
              this.qnaData = {
                userName: '',
                userEmail: '',
                phone: '',
                userContents: '',
                flag: 3
              }
              this.orderData = {
                userName: '',
                userEmail: '',
                phone: '',
                userContents: '',
                flag: 4
              }
            }
          })
          .catch(error => {
            console.log('err:::', error)
            alert('입력된 정보를 확인해 주세요.')
          })
      }
    },
    goHandy () {
      var id = this.userId
      var pw = this.crypto(this.userPw)
      this.userId = ''
      this.userPw = ''
      this.chkUserPw = ''
      window.open(`https://sery.sery.co.kr/#/?id=${id}&pw=${pw}`)
      // window.open(`http://localhost:8080/#/?id=${id}&pw=${pw}`)
    },
    crypto (value) {
      return CryptoJS.AES.encrypt(value, 'handysecretkey').toString()
    },
    numberWithCommas (x) {
      if (!x) {
        return '0'
      } else if (x === 0 || x === '0') {
        return ''
      } else {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    openJoin () {
      this.joinFlag = 0
      this.$gtag.event(`PC_홈페이지_무료체험신청클릭`, {
        'event_category': 'PC_기능'
      })
      this.$modal.show('promoModal')
    },
    async joinSery () {
      if (this.$empty(this.userPw) || this.userPw.length < 4) {
        alert('비밀번호는 4자리 이상 입력해주세요.')
        return
      }
      var result = localStorage.getItem('result')
      var LAMBDA_API = 'https://dzgneh35a3.execute-api.ap-northeast-2.amazonaws.com/prod'
      // var LAMBDA_API = 'http://localhost:3000'
      var objData = {
        storeSeq: '',
        storeId: this.userId,
        storePwd: this.userPw
      }
      if (this.userPw !== this.chkUserPw || (this.$empty(this.userPw) || this.$empty(this.chkUserPw))) {
        alert('패스워드가 일치하지 않습니다.')
      } else if (!this.$empty(objData.storeId)) {
        var chkDup = await chkDuplicateId()
        if (chkDup > 0) {
          alert('아이디가 중복되었습니다.')
        } else {
          this.$gtag.event(`PC_홈페이지_무료체험신청완료`, {
            'event_category': 'PC_기능'
          })
          var func2 = ''
          var func1 = await getMaxStoreSeq()
          console.log('1st:::', func1)
          if (func1 === 'success1') {
            func2 = await insertJoinsery()
            if (func2 === 'success2') {
              this.joinFlag = 1
            }
          }
        }
      }
      function chkDuplicateId () {
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: LAMBDA_API + '/chkDuplicateId',
            params: {
              id: objData.storeId
            }
          })
            .then((response) => {
              resolve(response.data[0].cnt)
            })
        })
      }
      function getMaxStoreSeq () {
        return new Promise((resolve, reject) => {
          axios({
            method: 'get',
            url: LAMBDA_API + '/getMaxStoreSeq',
            params: {
              store_seq: '0001234567'
            }
          })
            .then((response) => {
              console.log('1:::', response)
              objData.storeSeq = response.data
              resolve('success1')
            })
        })
      }
      function insertJoinsery () {
        return new Promise((resolve, reject) => {
          var formData = new FormData()
          var type = 0
          if (result.type !== undefined && result.type.trim() !== '') {
            if (result.type.trim() === '마트') {
              type = 0
            } else if (result.type.trim() === '외식') {
              type = 1
            } else if (result.type.trim() === '기타') {
              type = 2
            } else if (result.type.trim() === '정육') {
              type = 3
            }
            var storeManager = ''
            if (result.type.trim() === '정창모') {
              storeManager = 'si_00000046'
            }
            if (result.type.trim() === '좋은슈퍼') {
              storeManager = 'si_00000047'
            }

            formData.append('storeType', type)
            formData.append('category', result.type.trim())
            formData.append('storeManager', storeManager)
          } else {
            formData.append('storeType', 0)
            formData.append('category', '마트')
          }
          formData.append('storeSeq', objData.storeSeq)
          formData.append('storeName', '신규가입매장')
          formData.append('bsrn', '1231212345')
          formData.append('storeAddr', '부산 해운대구 센텀북대로 60 (센텀아이에스타워))')
          formData.append('lat', 35.17665784125602)
          formData.append('lng', 129.12537592501636)
          formData.append('detailAddr', '')
          formData.append('storeTel', '0001234567')
          formData.append('storeBirthday', '19700101')
          formData.append('storePay', 20)
          formData.append('storePartner', 1)
          formData.append('admin_agency', 1)
          formData.append('startTime', '0000')
          formData.append('endTime', '0000')
          formData.append('storeBreak', '연중무휴')
          formData.append('storePage', '0000')
          formData.append('minCharge', 300000)
          formData.append('DELIVERY_FLAG', 0)
          formData.append('PUBLIC_FLAG', 1)
          formData.append('pwdValue', '')
          formData.append('memo', '')
          formData.append('storeCeo', '신규가입고객님')
          formData.append('storePhone', null)
          formData.append('storeEmail', 'new@new.com')
          formData.append('storeId', objData.storeId)
          formData.append('storePwd', objData.storePwd)
          formData.append('business', '소매')
          axios({
            method: 'post',
            url: LAMBDA_API + '/insertSeryStore',
            data: formData
          })
            .then((response) => {
              console.log('2:::', response)
              if (response.data === 'success') {
                resolve('success2')
              }
            })
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('./css/main.css');
</style>



// WEBPACK FOOTER //
// src/components/main.vue